import { LoadingView } from "@app/components/Loading";
import { LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY } from '@app/constants/Common';
import { DVTJCUVWorkWithRecParentTabs, DVTJCUVWorkWithRecSendEmailInviteJobTabs, DVTJCUVWorkWithRecCallChatDnRecUpdateInfoTabs } from '@pages/dvtjcuv/common/WorkWithRecTabs';
import ConnectCddEmpSendMailTabContent from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/ConnectCddEmpSendMailTabContent';
import DVTJCUVPipelineNextStragyCompaignGroupList from '@pages/dvtjcuv/rundvtjcuv/DVTJCUVPipelineNextStragyCompaignGroupList';
import RunDVTJCUVCandidateList from '@pages/dvtjcuv/rundvtjcuv/RunDVTJCUVCandidateList';
import { TodoWCddSortOrder } from "@pages/dvtjcuv/common/Constant";
import {calculateYearsBetweenDates, convertVNDateTimeToDate} from '@app/utils/DateTimeUtils';
import HeaderSearchButtons from '@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons';
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import { React, useEffect, useState } from 'react';
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";

const PipeLineSortOption = {
    NOTE_TIME_ASC: '1',
    NOTE_TIME_DESC: '2',
    FU_SCHEDULE_NEXT_TIME_ASC: '3',
    FU_SCHEDULE_NEXT_TIME_DESC: '4',
}

const WorkWithRecContent = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [childTabList, setChildTabList] = useState([]);
    const [pipelineList, setPipelineList] = useState([]);
    const [dataInfo, setDataInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState(PipeLineSortOption.NOTE_TIME_ASC);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sortColumns, setSortColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    const {cddId, data, parentTab, onChangeRootTab} = props
    
    useEffect(() => {
        let loginUser = {};
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO));
            setUserLoginInfo(loginUser);
        }
    }, []);

    const sortByConditions = (inputPipelines, sortOption) => {
        //TODO: không tìm thấy chỗ map yc nội dung này nữa
        // if (parentTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB) {
        //     return inputPipelines.sort((a, b) => {
        //         // Sắp xếp theo `to_do_w_sort_order` tăng dần
        //         if (a.to_do_w_cdd_sort_order !== b.to_do_w_cdd_sort_order) {
        //             return a.to_do_w_cdd_sort_order - b.to_do_w_cdd_sort_order;
        //         }
        //         // Nếu `to_do_w_cdd_sort_order` bằng nhau, sắp xếp theo `created_date_time (note_time)` giảm dần hoặc tăng dần tuỳ theo điều kiện SortBy
        //         if (sortOption === PipeLineSortOption.NOTE_TIME_DESC) {
        //             return b.id - a.id;
        //         }
        //         return a.id - b.id;
        //     });
        // }


        // return inputPipelines.sort((a, b) => {
        //     if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_ASC || sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_DESC) {
        //         const aDate = convertVNDateTimeToDate(a.next_fu_schedule_date_time);
        //         const bDate = convertVNDateTimeToDate(b.next_fu_schedule_date_time);
        //         // Nếu `dateA` là null hoặc trống, đưa nó xuống cuối
        //         if (aDate === null && bDate !== null) return 1;
        //         if (aDate !== null && bDate === null) return -1;

        //         // Nếu cả hai đều là null hoặc trống, coi chúng là bằng nhau
        //         if (aDate === null && bDate === null) return 0;
        //         if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_ASC) {
        //             return aDate - bDate;
        //         }

        //         if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_DESC) {
        //             return bDate - aDate;
        //         }
        //     }


        //     if (sortOption === PipeLineSortOption.NOTE_TIME_DESC) {
        //         return b.id - a.id;
        //     }
        //     return a.id - b.id;
        // });
        return inputPipelines
    }

    const getTodoWCddSortOrder = (item) => {
        if (item.to_do_w_cdd) {
            return TodoWCddSortOrder.findIndex((value) => {
                return value.toLowerCase() === item.to_do_w_cdd.toLowerCase();
            });
        }
        return TodoWCddSortOrder.length
    }

    const setDisplayPipelineList = (pipes, sortOption) => {
        const duringNextOneYearItems = []
        const overNextOneYearItems = []
        const otherItems = []
        const currentTime = new Date()
        pipes.forEach((item, index) => {
            item.no = index + 1
            item.hightlight_class = ''
            item.to_do_w_cdd_sort_order = getTodoWCddSortOrder(item);
            if (item.has_find_job_mode_on && item.current_find_job_mode_note_time) {
                const noteDateTime = new Date(item.current_find_job_mode_note_time)
                if (calculateYearsBetweenDates(noteDateTime, currentTime) <= 1) {
                    item.hightlight_class = 'text-danger text-bold'
                    duringNextOneYearItems.push(item);
                } else {
                    item.hightlight_class = 'text-primary'
                    overNextOneYearItems.push(item);
                }
            } else {
                otherItems.push(item)
            }
        });
        setPipelineList(
            [
                ...sortByConditions(duringNextOneYearItems, sortOption),
                ...sortByConditions(overNextOneYearItems, sortOption),
                ...sortByConditions(otherItems, sortOption)
            ]
        );
    }

    const fetchPipeLines = async (pTab, subTab, sorts, searchConds) => {
        if (!searchConds) {
            searchConds = {}
        }

        searchConds.parent_tab = pTab?.id
        searchConds.sub_tab = subTab?.id
        searchConds.unlimited = true

        const params = {
            search_conditions: searchConds,
            sort_columns: sorts || sortColumns
        }

        setLoading(true)
        const res = await requestGetDVTJCUVPipeLineList(params);
        setLoading(false)

        const resContent = res.content
        // setPipelineList(resContent.pipelines);
        setDisplayPipelineList(resContent.pipelines, sortColumns)
    }


    // const onSort = async (columnKey) => {
    //     let newSorts = {...sortColumns};
    //     if (newSorts[columnKey] && newSorts[columnKey] === ORDER_BY.ASC) {
    //         newSorts[columnKey] = ORDER_BY.DESC;
    //     } else {
    //         newSorts = {};
    //         newSorts[columnKey] = ORDER_BY.ASC;
    //     }
    //     setSortColumns(newSorts);
    //     await fetchPipeLines(parentTab, currentTab, newSorts);
    // };

    // Function set tab content, return sub tab
    const setTabContents = (pTab) => {
        setParentOfTab(pTab)
        if (pTab && pTab.childTabs) {
            const childTabs = Object.values(pTab.childTabs)
            const hash = window.location.hash.substring(1);
            const activeChild = childTabs.find(t => t.id === hash) || childTabs[0];
            setCurrentTab(activeChild)
            setChildTabList(childTabs)
            fetchPipeLines(pTab, currentTab, sortColumns)
            return activeChild
        }
        return {}
    }

    useEffect(() => {
        if (parentTab) {
            // fetchPipeLines(parentTab);
            setTabContents(parentTab);
        }
        if (data) {
            setDataInfo(data);
        }
    }, [data, parentTab]);

    useEffect(() => {
        console.log("parentTab:" + JSON.stringify(parentTab))
        if (parentTab) {
            const subTab = setTabContents(parentTab)

            // Chỉ những tab ko có childs mới get piplines, các tabs có childs đã set riêng trong createTabContent rồi.
            if (childTabList.length === 0) {
                // fetchPipeLines(parentTab, subTab)
            }
        }
        if (data) {
            setDataInfo(data)
        }

    }, [data, parentTab]);

    const onTabClicked = async (tab) => {
        console.log("tab:" + JSON.stringify(tab))
        console.log("parentTab:" + JSON.stringify(parentTab))
        setCurrentTab({...tab});
        if (tab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.NEED_FU_TAB.id) {
            await fetchPipeLines(tab)
        }
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const createTabContent = (subTab) => {
        if (parentTab.id === DVTJCUVWorkWithRecParentTabs.SEND_EMAIL_INVITE_JOB_TAB.id) {
            if (subTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_TAB.id
                 || subTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id) {
                return <ConnectCddEmpSendMailTabContent
                parentTab={currentTab}
                onChangeParentTab={onTabClicked}/>
            }
            if (subTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.NEED_FU_TAB.id) {
                return <DVTJCUVPipelineNextStragyCompaignGroupList
                    pipelineIds={pipelineList.map(item => {return item.id})}
                    parentTab={subTab}
                    mode={EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU}
                />
            }
        }

        if (parentTab.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id) {
            return <>
                <RunDVTJCUVCandidateList runJob={dataInfo}
                            inputCandidateIds={pipelineList.map(item => item.cdd_id)}
                            requireFilterInputCandidateIs
                            onChangeTab={onTabClicked}
                            parentTab={parentTab}
                            subTab={currentTab}
                />
            </>
        }

        if (parentTab.id === DVTJCUVWorkWithRecParentTabs.SEND_EMAIL_DN_REC_UPDATE_INFO_TAB.id) {
            if (subTab.id === DVTJCUVWorkWithRecCallChatDnRecUpdateInfoTabs.SEND_EMAIL_TAB.id) {
                return <ConnectCddEmpSendMailTabContent
                    parentTab={subTab}
                    onChangeParentTab={onTabClicked}/>
            }
            return <>
                <div id={subTab.id} className={`tab-pane ${activeTab(subTab)}`}
                                        style={{height: '83vh', overflow: 'auto'}}
                                        key={`run-job-sub-tab-content-${parentTab.id}-${subTab.id}`}>
                    
                    <RunDVTJCUVCandidateList runJob={dataInfo}
                                            inputCandidateIds={pipelineList.map(item => item.cdd_id)}
                                            requireFilterInputCandidateIs
                                            onChangeTab={onTabClicked}
                                            parentTab={parentOfTab}
                                            subTab={subTab}/>
                </div>
            </>
            
        }
        
        return <></>
    }

    const onChangeSortOption = (event) => {
        setSortBy(event.target.value)
        // setDisplayPipelineList([...pipelineList], event.target.value)
    }


    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentTab.title}</b></h3>
                        <div className={"card-tools row"}>
                        {currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.NEED_FU_TAB.id &&
                            <HeaderSearchButtons
                                showBtnSearchPipeline
                                showBtnSearchReceiver
                                parentTabId={parentOfTab?.id}
                                tabId={currentTab?.id}
                            />
                        }
                        {(currentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.NEED_FU_TAB.id) &&
                            <div className={'col-sm-3 ml-3'}>
                                <select className='mr-0'
                                        style={{
                                            padding: '0.25rem',
                                            border: '1px solid #ced4da',
                                            borderRadius: '0.25rem',
                                            boxShadow: 'inset 0 0 0 transparent',
                                            transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                                        }}
                                        name={'sortBy'}
                                        value={sortBy}
                                        onChange={event => onChangeSortOption(event)}>
                                    <option value={PipeLineSortOption.NOTE_TIME_ASC}>Note time xa hiện tại hơn lên
                                        trước
                                    </option>
                                    <option value={PipeLineSortOption.NOTE_TIME_DESC}>Note time gần hiện tại hơn lên
                                        trước
                                    </option>
                                </select>
                            </div>
                        }
                        </div>
                    </div>

                    <div className="card-body p-0">
                        {childTabList && childTabList.length > 0 ? (
                        <div style={{position: 'relative'}}>
                            <ul className='nav nav-tabs' role='tablist'>
                            {childTabList.map(tab => (
                                <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                    <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                                    onClick={() => onTabClicked(tab)}>{tab.title}
                                        ({mailTabData[tab.id] ? mailTabData[tab.id] : 0})
                                    </a>
                                </li>
                            ))}
                            </ul>
                            <div className='tab-content'>
                                {childTabList.map((tab, index) => {
                                    if (currentTab.id === tab.id) {
                                        return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                    style={{height: '83vh', overflow: 'auto'}}
                                                    key={`run-dvtjcuv-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                            {createTabContent(currentTab)}
                                        </div>
                                    }
                                    return "";
                                })}
                            </div>
                        </div>
                        ) : (
                        <>
                            {createTabContent(currentTab)}
                        </>
                        )}
                    </div>
                </div>
            </div>
            {isLoading &&
                <LoadingView />
            }
        </>
    );
};

export default WorkWithRecContent; 